<template>
    <div>
      <div class="row">
        <div class="col">
          <h1>Edit a coupon</h1>
        </div>
      </div>
  
      <form class="mt-4" @submit.prevent="saveCoupon">
        <div class="form-group">
          <label for="start">
            <small class="text-muted">Code</small>
          </label>
          <input type="text" class="form-control" name="code" placeholder="Code" v-model="code" required autofocus
            :disabled="loading" />
        </div>
        <div class="form-group">
          <label for="end">
            <small class="text-muted">Discount</small>
          </label>
          <input type="number" class="form-control" name="discount" placeholder="Discount" v-model.number="discount" step="0.01" required autofocus
            :disabled="loading" />
        </div>
        <div class="form-group">
          <label for="new_price">
            <small class="text-muted">End Date</small>
          </label>
          <input type="text" class="form-control" name="end_Date" placeholder="End_Date" v-model="endDate" required
            autofocus :disabled="loading" />
        </div>
        <button type="submit" class="btn btn-primary ld-ext-right mt-3" :disabled="loading" :class="{ running: loading }">
          {{ loading ? "Saving…" : "Save" }}
          <div class="ld ld-ring ld-spin" />
        </button>
      </form>
  
      <div class="alert alert-danger mt-4" v-if="!loading && error">
        <p class="mb-0 text-center">{{ error }}</p>
      </div>
    </div>
  </template>
  
  
  <script>
  import store from "../../../store";
  import { getError } from "../../../helpers";
  import { mapGetters, mapState } from "vuex";
  import FileInput from "../../FileInput";
  
  export default {
    components: {
      "file-input": FileInput,
    },
  
    async beforeRouteEnter(to, from, next) {
      await store.dispatch("coupons/fetchAll");
  
      return store
        .dispatch("coupons/fetch", { id: to.params.id })
        .then((coupon) => {
          next((vm) => {
            vm.code = coupon.code;
            vm.discount = coupon.discount;
            vm.endDate = coupon.endDate;
          });
        });
    },
  
    data() {
      return {
        code: "",
        discount: "",
        endDate: "",
        loading: false,
        error: "",
      };
    },
  
    computed: {
      ...mapGetters({
        getCouponsById: "coupons/getById",
      }),
  
      coupon() {
        return this.getCouponsById(parseInt(this.$route.params.id));
      },
  
      ...mapState({

      }),
    },
  
    methods: {
      saveCoupon() {
        this.loading = true;
  
        return this.$store
          .dispatch("coupons/update", {
            id: this.$route.params.id,
            code: this.code,
            discount: this.discount,
            endDate: this.endDate,
          })
          .then(() => {
            this.$router.push({ name: "coupons" });
          })
          .catch((e) => {
            this.error = getError(e);
            this.loading = false;
          });
      },
  
    //   fetchAgain({ oldValue }) {
    //     this.loading = true;
  
    //     this.$store
    //       .dispatch("offers/update", {
    //         id: this.offers.id,
    //         product_id: this.product_id,
    //         start_date: this.start,
    //         end_date: this.end,
    //         new_price: this.new_price,
    //         notes: this.notes,
    //       })
    //       .then(async () => {
    //         const offers = await this.$store.dispatch("offers/fetch", {
    //           id: this.$route.params.id,
    //         });
  
    //         this.product_id = offers.product_id;
    //         this.start = offers.start_date;
    //         this.end = offers.end_date;
    //         this.new_price = offers.new_price;
    //         this.notes = offers.notes;
    //       })
    //       .catch((e) => {
    //         this.$store.dispatch("setContentLocale", oldValue);
    //         this.error = getError(e);
    //       })
    //       .finally(() => {
    //         this.loading = false;
    //       });
    //   },
    },
  
    meta: {
      title: "Edit a coupon",
  
      meta: [{ property: "og:title", content: "Edit a coupon / Shayah" }],
    },
  };
  </script>
  
  